import { mapToCompanyInfoList } from 'helpers/mapToCompanyInfoList';
import { IPartnerSimpleInfoItem, IPartnerList } from '../models';
import { ICompanyList } from '../../../models';

export function mapPartnerList(
	list: IPartnerList,
	titles: IPartnerSimpleInfoItem[],
): ICompanyList {
	return list.map((partner) => ({
		id: partner.id,
		logoUrl: partner.logoUrl,
		formalName: partner.formalName,
		allowedLimit: partner.surveyCountLimit,
		sent: partner.surveyCount,
		infoList: mapToCompanyInfoList(
			(partner as unknown) as Record<string, number>,
			titles,
		),
		deleted: partner.deleted,
	}));
}
